import { render, staticRenderFns } from "./ServerDisplay.vue?vue&type=template&id=1724ddd0&scoped=true&"
import script from "./ServerDisplay.vue?vue&type=script&lang=js&"
export * from "./ServerDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ServerDisplay.vue?vue&type=style&index=0&id=1724ddd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1724ddd0",
  null
  
)

export default component.exports